import React, { useState, useRef, useEffect } from "react";

function AutoResizeTextarea({ value, onChange, placeholder, readOnly }) {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // 초기화
      textareaRef.current.style.height = textareaRef.current.scrollHeight + "px"; // 내용 기반 높이 조정
    }
  }, [value]);

  return (
    <div style={{position: "relative", width: "100%", display: "flex", flexDirection: "column"}}>
        <textarea
            ref={textareaRef}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            rows={1}
            maxLength={1000}
            readOnly={readOnly}
            style={{
                boxSizing: "border-box",
                width: "100%",
                resize: "none",
                overflow: "hidden",
                padding: "10px 8px",
                lineHeight: "1.4",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ccc",
            }}
        />
        <span className="text-length">{value.length}/1,000자</span>
    </div>
  );
}

export default AutoResizeTextarea;